import { ICON_TYPES } from '../constants';

export const Expandbutton = (): JSX.Element => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.999 8L18.999 1M18.999 1H12.999M18.999 1V7M7.99902 12L0.999023 19M0.999023 19H6.99902M0.999023 19L0.999024 13" stroke="white" style={{ stroke: 'white', strokeOpacity: 1 }} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

Expandbutton.iconType = ICON_TYPES.EXPAND_ICON;
